export default "__VITE_ASSET__upIBMPpO__"